import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const images = ['https://images.unsplash.com/photo-1578683010236-d716f9a3f461?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1611892440504-42a792e24d32?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1572116469696-31de0f17ce34?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'];
  return <div className="w-full bg-club-canvas" data-id="element-874">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-875">
        <div className="absolute inset-0 z-0 bg-club-navy" data-id="element-876">
          <div className="absolute inset-0 opacity-20" data-id="element-877">
            <img src="https://images.unsplash.com/photo-1578683010236-d716f9a3f461?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Gallery Background" className="w-full h-full object-cover" data-id="element-878" />
          </div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-879">
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-880">
            Gallery
          </motion.h1>
          <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-881">
            A visual journey through Andhra Social & Cultural Association.
          </motion.p>
        </div>
      </section>

      {/* Image Grid */}
      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-882">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-883">
          {images.map((src, index) => <motion.div key={index} className="aspect-square overflow-hidden rounded-sm relative group cursor-pointer" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.5
        }} data-id="element-884">
              <img src={src} alt={`Gallery image ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-885" />
              <div className="absolute inset-0 bg-club-navy/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-886"></div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}